import { Route } from "react-router-dom";
// import NeqatyLogin from "../pages/NeqatyLogin";
import Neqaty from "../pages/Neqaty";
import NeqatySchool from "../pages/NeqatySchool";
import NeqatyVtc from "../pages/NeqatyVtc";
import NeqatySchoolPermissions from "../pages/NeqatySchoolPermission";
import NeqatyVtcPermissions from "../pages/NeqatyVtcPermissions";
import ProtectedRoute from "components/ProtectedRoute";

export const NeqatyRoutes = () => [
    // <Route key="neqaty login" path="/neqaty/login" element={<NeqatyLogin />} />,
    <Route key="neqaty main page" path="/neqaty" element={
        <ProtectedRoute>
            <Neqaty />
        </ProtectedRoute>
    } />,
    <Route key="neqaty school" path="/neqaty/schools" element={
        <ProtectedRoute>
            <NeqatySchool />
        </ProtectedRoute>
    } />,
    <Route key="neqaty vtc" path="/neqaty/vtcs" element={
        <ProtectedRoute>
            <NeqatyVtc />
        </ProtectedRoute>
    } />,
    <Route key="neqaty school permission" path="/neqaty/school-permissions" element={
        <ProtectedRoute>
            <NeqatySchoolPermissions />
        </ProtectedRoute>
    } />,
    <Route key="neqaty vtc permission" path="/neqaty/vtc-permissions" element={
        <ProtectedRoute>
            <NeqatyVtcPermissions />
        </ProtectedRoute>
    } />,
];